import { useCallback, useEffect, useState } from "react";
import { useVersionQuery } from "../../react-query/version/queries";

const useVersionCheck = () => {
  const { data: versionData } = useVersionQuery();

  const [currentVersion, setCurrentVersion] = useState<string | null>(null);
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);

  // 버전 체크 로직
  const checkVersion = useCallback(() => {
    if (!versionData?.version) return;

    // 최초 마운트 시 현재 버전 저장
    if (!currentVersion) {
      setCurrentVersion(versionData.version);
      return;
    }

    // 버전 비교(롤백이 있을 수 있어서 문자열 비교)
    if (versionData.version !== currentVersion) {
      setIsNewVersionAvailable(true);
    }
  }, [versionData, currentVersion]);

  // 페이지 새로고침
  const reloadPage = useCallback(() => {
    window.location.reload();
  }, []);

  // 버전 데이터가 변경될 때마다 체크
  useEffect(() => {
    checkVersion();
  }, [versionData, checkVersion]);

  return {
    isNewVersionAvailable,
    reloadPage,
  };
};

export default useVersionCheck;
